var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.position.x,
        "position-y": _vm.position.y,
        "close-on-content-click": false,
        "nudge-width": 600,
        "offset-x": "",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title py-1" },
                [
                  _c("div", [
                    _c("div", { staticClass: "pt-1" }, [
                      _vm._v(" " + _vm._s(_vm.type) + " reports sent"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "caption py-1" },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("account_circle"),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.recipientName) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-subheader", [_vm._v("Send reports...")]),
                  _vm._v(" "),
                  _c("SelectReports", {
                    ref: "selectReports",
                    attrs: {
                      search: _vm.search,
                      filterToggle: _vm.filterToggle,
                      filterToggles: _vm.filterToggles,
                      entity: _vm.reports,
                      "item-name": "Reports",
                      "entity-description": "description",
                      "entity-name": "name",
                      "hide-category-icons": "",
                    },
                    on: {
                      isSearching: function ($event) {
                        _vm.issearching = $event
                      },
                      selected: function ($event) {
                        return _vm.onSelection($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Save")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }